<template>
  <div class="printContent">
    <section class="printHeader d-none d-print-block">
      <div class="row align-items-center">
        <div class="col-4" >
          <div class="text-left neo_id_card_school_logo">
            <a-avatar :size="75" shape="square" :src="schoolData ? schoolData.logo : user.user.school.logo" />
            <!-- <img size="75" src="@/assets/logo/logo.jpg"/> -->
          </div>
        </div>
        <div class="col-4" style="justify-content: center">
          <div class="d-flex" style="text-align: center">
            <!-- &nbsp; -->
            <div
              class="pl-0 neo_id_card_school_name"
              style="text-align: center"
            >
              <h5 class="mb-0">
                {{
                  schoolData
                    ? schoolData.name
                    : user.user.school.name.toUpperCase()
                }}

              <p class="mb-0"><span style="font-size:13px">
                {{
                  schoolData
                    ? schoolData.contact.address
                    : user.user.school.contact.address.toUpperCase()
                }},
                {{
                  schoolData
                    ? schoolData.contact.city
                    : user.user.school.contact.city.toUpperCase()
                }},
                {{
                  schoolData
                    ? schoolData.contact.state
                    : user.user.school.contact.state.toUpperCase()
                }}
                -
                {{
                  schoolData
                    ? schoolData.contact.pincode
                    : user.user.school.contact.pincode.toUpperCase()
                }}
                </span>
              </p>

              <p class="mb-0"><span style="font-size:11px">{{title}}</span></p>
              </h5>
              <!-- <p class="mb-0">
                    Reg. No.: <span>{{schoolData ? schoolData.registration_no : user.user.school.registration_no}}</span>
                </p> -->
              <!-- <h5 class="mb-0">{{ title }}</h5> -->
<!--              <b><span style="font-size:12px">Progress Report Card</span></b>-->
            </div>
          </div>
        </div>
         <div class="col-4">
           <div class="text-left neo_id_card_school_logo">
                <!-- <a-avatar :size="75" shape="square" :src="schoolData ? schoolData.logo : user.user.school.logo" /> -->
                <!-- <a-avatar :size="80" icon="user" /> -->
            </div>
        </div>
      </div>
      <hr />
    </section>

    <section class="printBody">
      <slot></slot>
    </section>

    <section v-if="footer" class="printFooter d-none d-print-block">
      <hr />
      <div class="d-flex justify-content-between">
        <div>
          <p>skoolsync | {{ moment().format("YYYY") }}</p>
        </div>
        <div class="text-right">
          <p>{{ moment().format("LLL") }}</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import moment from 'moment'
import { mapState } from 'vuex'

export default {
  name: 'NeoPrintWrapper',
  props: ['title', 'footer', 'schoolData'],
  computed: {
    ...mapState(['settings', 'user']),
  },
  methods: {
    moment,
  },
}
</script>
